import React from "react";
import image from "../assets/images/coin.jpg";
import TopHeader from "../components/TopHeader";
import AboutSection from "../components/AboutSection";
import HelpSection from "../components/HelpSection";
import CoreValues from "../components/CoreValues";

const AboutUs = () => {
  return (
    <section className="bg-gray-100 min-h-screen pb-8">
      <div
        className="relative bg-cover bg-center h-100 items-center flex justify-center"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <TopHeader title="about us" subtitle="about us" />
      </div>
      <div className="bg-white max-w-6xl mx-auto w-full p-4">
        <AboutSection />
        <CoreValues />
        <HelpSection />
      </div>
    </section>
  );
};

export default AboutUs;
